import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { analytics } from 'core/analytics';

import { Wizard } from 'libs/wizards/index';
import DocumentHead from 'legacyComponents/documentHead';

import { clientStore } from 'apps/client/app';
import { SignUpAppManager } from 'apps/profile/signUp/appManager';

import { Divider } from 'components';
import { WikiWrapper } from 'apps/components';

@inject('routerStore')
@withNamespaces()
@observer
export class SignUp extends React.Component {
  UNSAFE_componentWillMount() {
    if (
      clientStore.signedInProfile &&
      clientStore.signedInProfile.profileConfirmed
    ) {
      clientStore.routerStore.navigate('home');
    }
    this.appManager = new SignUpAppManager(null, this.props);
    const username = this.props.params.get('username');
    const email = this.props.params.get('email');
    const password = this.props.params.get('password');
    if (username) {
      this.appManager.signUpApp.user.username = username;
    }
    if (email) {
      this.appManager.signUpApp.user.email = email;
    }
    if (password) {
      this.appManager.signUpApp.user.password = password;
      clientStore.routerStore.params.set('password', '');
    }
    if (username && email && password) {
      this.appManager.signUpApp.wizard.Next();
    }

    if (clientStore.routerStore.route.path === '/sign-up?next=%2Fmake-part') {
      analytics.sendEvent(
        'AddToWishlist',
        { value: 12, currency: 'EUR' },
        { facebook: true },
      );
    }
  }

  render() {
    const { t } = this.props;

    return (
      <WikiWrapper>
        <DocumentHead title={`${t('Sign up')}`} index='noindex' />
        <div className='flex items-center justify-center flex-grow'>
          <Wizard
            className='flex items-center'
            noPadding
            isSideBarForm
            spacing='medium'
            prefix='Sign up'
            descriptionClassName='flex p-2 justify-center text-black'
            socialWrapperClassName='flex w-full justify-center'
            divider={<Divider text='Or' />}
            actionWrapperStyle={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              margin: '16px auto 10px',
            }}
            actionStyle={{
              marginTop: 0,
              background: '#000',
              borderColor: '#000',
            }}
            formTitleStyle={{
              display: 'flex',
              margin: '0 auto',
              justifyContent: 'center',
            }}
            wizard={this.appManager.signUpApp.wizard}
          />
        </div>
      </WikiWrapper>
    );
  }
}

SignUp.propTypes = {
  t: PropTypes.func,
  params: PropTypes.object,
};
